const ROOTS = {
  host: {
    development: 'http://api-hiya-test.youyisia.com',
    // development: 'http://api.mehiya.com',
    test: 'http://api-hiya-test.youyisia.com',
    // production: 'http://api.mehiya.com',
    production: 'http://api.in.mehiya.com',
  }
}

const roots2Proxies = (env) =>
  Object.entries(ROOTS).map(([key, value]) => {
    return {
      match: `/${key}`,
      map: (path) => path.replace(`/${key}`, ''),
      host: value[env],
    }
  })
module.exports = {
  ROOTS,
  production: {
    ENV: 'production',
    staticServerIps: ['10.0.0.118', '10.0.0.170','10.0.2.4'],
    staticServerHost: 'static.mehiya.com',
    proxies: roots2Proxies('production'),
  },
  test: {
    ENV: 'test',
    staticServerIps: ['172.30.43.74'],
    staticServerHost: 'static-hiya-test.youyisia.com',
    proxies: roots2Proxies('test'),
  },
  development: {
    ENV: 'development',
    proxies: roots2Proxies('development'),
  },
}
